import { useMutation } from '@tanstack/react-query';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { loanSignPragmaSuccessResponseBodySchema, loanSignLiberisSuccessResponseBodySchema, } from './loan-sign.schema';
var apiEndpoint = apiPaths.loan.sign;
function postLoanSignPragma(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'POST', body: JSON.stringify(payload) },
        successSchema: loanSignPragmaSuccessResponseBodySchema,
    });
}
function postLoanSignLiberis(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'POST', body: JSON.stringify(payload) },
        successSchema: loanSignLiberisSuccessResponseBodySchema,
    });
}
export function usePostLoanSignPragma() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: postLoanSignPragma,
        onError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
export function usePostLoanSignLiberis() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: postLoanSignLiberis,
        onError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
